import 'bootstrap';

(function () {
    $(function () {
        // TODO hande file upload
        $('body').on('click', '.js-modal-form', function (event : JQuery.Event): void {
            event.preventDefault();
            event.stopPropagation();

            const $this = $(this);

            $.ajax({
                method: 'get',
                url: $this.data('form-url')
            }).done(function (response : AppResponse): void {
                const $modal : JQuery<HTMLElement> = $('.js-modal').first();
                $modal.find('.js-form-content').html(response.content);
                if (typeof $this.attr('data-trainer-id') !== 'undefined') {
                    const option : string = '#signup_form_trainer option[value="' + $this.attr('data-trainer-id') +'"]';
                    $modal.find(option).attr('selected', 'selected').prop('selected', true);
                }
                $modal.modal();
            }).fail(function() {
                const $modal : JQuery<HTMLElement> = $('.js-modal').first();
                $modal.find('.js-form-content').html(
                '<div class="text-white alt-font text-large font-weight-600 text-uppercase">'
                + 'Przepraszamy, ale wystąpił błąd podczas ładowania formularza. Prosimy spróbować później.</div>'
                );
                $modal.modal();
            })
        });
    });
})();



// WEBPACK FOOTER //
// ./assets/typescript/form-modal.ts